import script from "./StartIDVerificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartIDVerificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./StartIDVerificationModal.vue?vue&type=style&index=0&id=f0234fa4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0234fa4"]])

export default __exports__